/*************
 * tabToggle
 * 
 * This module handles the tab toggle functionality for tabbed views in the application.
 *
 */

custom.tabToggle = (() => {
    

    const init = () => {
        $('.js-tab-toggle').on('click', function(event) {
            event.preventDefault();
            const $this = $(this);
            const showTarget = $this.data('target');
            const hideTarget = $this.data('hide');
            const scrollTarget = $this.data('scroll-target');
            
            // Add active class to the clicked tab and corresponding content
            $('.js-tab-toggle').each(function() {
                if($(this).data('target') === showTarget) {
                    $(this).addClass('active');
                    return;
                }
                $(this).removeClass('active');
            });

            $(showTarget).removeClass('hidden');
            $(hideTarget).addClass('hidden');
            if(scrollTarget && $(`#${scrollTarget}`).length) {
                const scrollPosition = $(`#${scrollTarget}`).offset().top - 80;
                window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }
        });
    }
  /**
   * API
   */
  return {
    init
  };
})();
custom.tabToggle.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/tab-toggle.js